import script from "./remoteControl.vue?vue&type=script&setup=true&lang=js"
export * from "./remoteControl.vue?vue&type=script&setup=true&lang=js"

import "./remoteControl.vue?vue&type=style&index=0&id=1fe55d6a&lang=scss"

const __exports__ = script;

export default __exports__